import { Loader } from '@googlemaps/js-api-loader';
import { makeObservable, observable, runInAction } from 'mobx';
import { BaseEntityStore } from './core/base.entity.store';
import { SessionStore } from './session.store';
import _ from 'lodash';

const loader = new Loader({
	apiKey: 'AIzaSyAS6Sik2T9tlF-aWgWWg44Lkup6TiwDOI4',
	version: 'weekly',
});

interface IMapSettings {
	zoom: number;
	lat: number;
	lng: number;
	mapId: string;
}

export class MapsStore extends BaseEntityStore<any> {
	mapsLib?: google.maps.MapsLibrary;
	markerLib?: google.maps.MarkerLibrary;
	loadingPromise?: Promise<boolean>;
	geocoder?: google.maps.Geocoder;

	@observable
	loadFailed: boolean = false;

	constructor(session: SessionStore) {
		super(session);
		makeObservable(this);

		// // Throttle _saveMapSettings and store it as a class property
		this.saveMapSettings = _.throttle((map: google.maps.Map) => {
			this._saveMapSettings(map);
		}, 1000);
	}

	// the maps script is only needed on map views, so it is loaded on first use
	// and not at app boot. rejections are caught here so a blocked
	// maps.googleapis.com (proxy, content blocker) does not surface as an
	// unhandled rejection (DVS2-111).
	ensureLoaded(): Promise<boolean> {
		if (!this.loadingPromise) {
			this.loadingPromise = loader
				.load()
				.then(async () => {
					this.mapsLib = (await google.maps.importLibrary('maps')) as google.maps.MapsLibrary;
					this.markerLib = (await google.maps.importLibrary('marker')) as google.maps.MarkerLibrary;
					runInAction(() => {
						this.loadFailed = false;
					});
					return true;
				})
				.catch((err) => {
					console.warn('Google Maps script could not be loaded', err);
					runInAction(() => {
						this.loadFailed = true;
					});
					this.loadingPromise = undefined;
					return false;
				});
		}
		return this.loadingPromise;
	}

	saveMapSettings: (map: google.maps.Map) => void;
	_saveMapSettings(map: google.maps.Map) {
		const center = map.getCenter();
		const zoom = map.getZoom();
		if (!center) {
			return;
		}

		const s: IMapSettings = {
			zoom: zoom || 8,
			lat: center.lat(),
			lng: center.lng(),
			mapId: 'agenturen',
		};
		console.log('saveMapSettings');
		localStorage.setItem('mapSettings', JSON.stringify(s));
	}

	getMapSettings(): IMapSettings {
		const s = localStorage.getItem('mapSettings');
		const defaultSettings = {
			lat: 51.0939,
			lng: 10.2656,
			zoom: 8,
			mapId: 'agenturen',
		};
		if (!s) {
			return defaultSettings;
		}
		const settings = JSON.parse(s);
		if (!settings.lat || !settings.lng || !settings.zoom) {
			return defaultSettings;
		}
		return {
			lat: settings.lat,
			lng: settings.lng,
			zoom: settings.zoom,
			mapId: 'agenturen',
		};
	}
}
